export enum TipoParametroModeloEnum {
  DATE = 'DATE',
  STRING = 'STRING',
  BOOLEAN = 'BOOLEAN',
  NUMBER = 'NUMBER'
}
